import { BRANDS } from "@/lib/site";

export const BrandsSection = ({ background = "light" }) => (
  <section
    data-testid="brands-section"
    className={background === "light" ? "bg-[#F4F6F8] py-20 lg:py-24" : "bg-white py-20 lg:py-24"}
  >
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#1F6FEB]">
        Product Brands
      </p>
      <h2 className="mt-4 text-3xl font-extrabold text-[#0B1F33] md:text-4xl">Brands We Offer</h2>
      <p className="mt-6 max-w-3xl text-base leading-relaxed text-[#263238]">
        Our product selection includes genuine branded automotive products from established
        manufacturers, including Bosch, Valeo, MANN-FILTER and FILTRON. Product selection and
        availability may vary.
      </p>

      <ul
        data-testid="brand-logo-grid"
        className="mt-12 grid grid-cols-2 gap-4 sm:gap-6 lg:grid-cols-4"
      >
        {BRANDS.map((brand) => (
          <li
            key={brand.slug}
            data-testid={`brand-${brand.slug}`}
            className="flex h-28 items-center justify-center rounded-lg border border-[#0B1F33]/10 bg-white p-6 sm:h-32 sm:p-8"
          >
            <img
              src={brand.logo}
              alt={brand.name}
              loading="lazy"
              decoding="async"
              className="max-h-16 w-auto max-w-full object-contain"
            />
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default BrandsSection;
